import { Link } from "react-router-dom";

export function NotFound() {
  return (
    <div className="flex flex-col items-center justify-center gap-3 p-16 text-center">
      <h1 className="text-lg font-extrabold" style={{ color: "var(--color-fg)" }}>
        Страница не найдена
      </h1>
      <p className="text-sm" style={{ color: "var(--color-muted)" }}>
        Адрес не существует или объект вам недоступен.
      </p>
      <Link
        to="/tasks"
        className="text-sm font-semibold underline"
        style={{ color: "var(--color-accent)" }}
      >
        Перейти к задачнику
      </Link>
    </div>
  );
}
